<template>
  <div class="home">
    <el-carousel :interval="2000"
                 indicator-position="none">
      <el-carousel-item v-for="(item,index) in swiperList"
                        :key="index"
                        :arrow="swiperList.length>1?'hover':'never'"
                        style="cursor: pointer;"
                        @click.stop.native="jumpUrl(item)">
        <el-image :src="item.img"
                  style="width: 100%;"
                  fit="cover" />
      </el-carousel-item>
    </el-carousel>
    <!-- 互联网赋能医疗健康 -->
    <div class="inter-health mobile-padding" v-if="visible">
      <div class="health-title title-big">{{ $t('home.interHealth') }}</div>
      <div class="health-content">
        <el-row>
          <el-col :xs="24"
                  :sm="24"
                  :md="12"
                  class="health-image">
            <el-image src="/svg/inter_health.svg"
                      fit="cover" />
          </el-col>
          <el-col :xs="24"
                  :sm="24"
                  :md="12">
            <div class="menu">
              <div v-for="(item,index) in interHealthList"
                   :key="index"
                   class="menu-item">
                <el-image :src="item.icon"
                          fit="cover" />
                <div class="item-text">{{ item.name }}</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 互联网医院 -->
    <div class="inter-hospital mobile-padding" v-if="visible">
      <el-row>
        <el-col :xs="24"
                :sm="24"
                :md="8">
          <div class="common-title ">{{ $t('home.yyInterHospital') }}</div>
          <div class="common-tip">{{ $t('home.hospitalInfo') }}</div>
          <!-- <div class="common-tip">{{ $t('home.hospitalInfo2') }}</div> -->
          <div class="common-btn">
            <el-button type="primary"
                       class="hidden-sm-and-down"
                       size="medium"
                       round
                       @click="jumpRoute('/interHospital/index')">{{ $t('home.commonBtn') }}</el-button>
            <el-button type="primary"
                       class="hidden-md-and-up"
                       size="small"
                       round
                       @click="jumpRoute('/interHospital/index')">{{ $t('home.commonBtn') }}</el-button>
          </div>
        </el-col>
        <el-col :xs="24"
                :sm="24"
                :md="16"
                style="text-align: right;">
          <el-image :src="hospitalUrl"
                    class="hospital-image hidden-sm-and-down"
                    fit="cover" />
          <el-image class="hospital-image hidden-md-and-up"
                    src="/img/hospital_feature_mobile.png"
                    fit="cover" />
        </el-col>
      </el-row>
    </div>
    <!-- 临床营养 -->
    <div class="clini_nutrit mobile-padding" v-if="visible">
      <el-row>
        <el-col :xs="24"
                :sm="24"
                :md="14"
                class="nutrition hidden-md-and-up">
          <div v-for="(item,index) in funcList"
               :key="index"
               class="nutrition-item">
            <el-image :src="item.mobile_icon"
                      fit="cover" />
            <div class="item-title">{{ item.title }}</div>
          </div>
        </el-col>
        <el-col :xs="24"
                :sm="24"
                :md="14"
                class="nutrition hidden-sm-and-down">
          <div v-for="(item,index) in nutritionList"
               :key="index"
               :style="{backgroundImage:`url(${item.icon})` }"
               class="nutrition-item">
            <div class="item-content">
              <div class="item-title">{{ item.title }}</div>
              <div class="item-tip">{{ item.tip }}</div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24"
                :sm="24"
                :md="10">
          <div class="common-title">{{ $t('cliniNutrit.cliniNutrit') }}</div>
          <!-- <div class="common-tip">{{ $t('home.cliniNutritTip1') }}</div>
          <div class="common-tip">{{ $t('home.cliniNutritTip2') }}</div> -->
          <div class="common-tip">{{ $t('home.cliniNutritTip') }}</div>
          <div class="common-btn">
            <el-button type="primary"
                       class="hidden-sm-and-down"
                       size="medium"
                       round
                       @click="jumpRoute('/cliniNutrit/index')">{{ $t('home.commonBtn') }}</el-button>
            <el-button type="primary"
                       class="hidden-md-and-up"
                       size="small"
                       round
                       @click="jumpRoute('/cliniNutrit/index')">{{ $t('home.commonBtn') }}</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 智慧药店 -->
    <div class="inter-hospital mobile-padding" v-if="visible"
         style="padding: 9.68vw 11vw">
      <el-row>
        <el-col :xs="24"
                :sm="24"
                :md="8">
          <div class="common-title">{{ $t('wisdomStore.wisdomStore') }}</div>
          <div class="common-tip">{{ $t('home.wisdomStoreTip1') }}</div>
          <!-- <div class="common-tip">{{ $t('home.wisdomStoreTip2') }}</div> -->
          <div class="common-btn">
            <el-button type="primary"
                       class="hidden-sm-and-down"
                       size="medium"
                       round
                       @click="jumpRoute('/wisdomStore/index')">{{ $t('home.commonBtn') }}</el-button>
            <el-button type="primary"
                       class="hidden-md-and-up"
                       size="small"
                       round
                       @click="jumpRoute('/wisdomStore/index')">{{ $t('home.commonBtn') }}</el-button>
          </div>
        </el-col>
        <el-col :xs="24"
                :sm="24"
                :md="16"
                style="text-align: right;">
          <el-image :src="storeUrl"
                    style="width: 37.5vw;"
                    class="hospital-image hidden-sm-and-down"
                    fit="cover" />
          <el-image class="hospital-image hidden-md-and-up"
                    src="/img/store_feature_mobile.png"
                    fit="cover" />

        </el-col>
      </el-row>
    </div>
    <!-- 技术优势 -->
    <div class="technical-super mobile-padding">
      <div class="technical-title">{{ $t('home.technicalSuper') }}</div>
      <div class="technical-temp hidden-sm-and-down">
        <div class="technical-content ">
          <div v-for="(item,index) in technicalList"
               :key="index"
               class="technical-item">
            <div class="item-title">{{ item.title }}</div>
            <div class="item-tip">{{ item.tip }}</div>
          </div>
        </div>
      </div>
      <div class="technical-temp-mobile hidden-md-and-up">
        <div v-for="(item,index) in technicalList"
             :key="index"
             class="technical-item">
          <el-image :src="item.icon"
                    fit="cover" />
          <div class="item-content">
            <div class="item-title">{{ item.title }}</div>
            <div class="item-tip">{{ item.tip }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { homeApi } from '@/api/homeApi'
import { homeObj, cliniNutritObj } from '@/const/crud/list'
import { vaildatePc } from '@/commonModule/utils/validate'

export default {
  name: 'Home',
  data() {
    return {
      funcList: cliniNutritObj.funcList,
      swiperList: [],
      interHealthList: homeObj.interHealthList,
      nutritionList: homeObj.nutritionList,
      technicalList: homeObj.technicalList,
      hospitalUrl: '/img/hospital_feature.png',
      storeUrl: '/svg/store_feature.svg'
    }
  },
  mounted() {
    this.changeImage()
    this.fetchSwiperData()
    window.addEventListener('resize', () => {
      this.changeImage()
    })
  },
  destroyed() {
    window.removeEventListener('resize', () => {
      this.changeImage()
    })
  },
  computed: {    
    visible() {
      return process.env.VUE_APP_VISIBLE !== 'false'
    }
  },
  methods: {
    async fetchSwiperData() {
      try {
        const res = vaildatePc() ? await homeApi.fetchSwiper() : await homeApi.fetchMobileSwiper({ type: 4 })
        this.swiperList = res.data.data.banner.filter(item => {
          return item.status == 1 || (item.status == 2 && +new Date(item.start_time) <= +new Date())
        })
      } catch (err) {
        console.error(err)
      }
    },
    jumpUrl(item) {
      if (item.url_type != 3) {
        window.open(item.url, '_blank')
      }
    },
    jumpRoute(src) {
      this.$router.push(src)
    },
    changeImage() {
      if (document.body.clientWidth > 992 && document.body.clientWidth < 1200) {
        this.hospitalUrl = '/img/hospital_feature_mobile.png'
        this.storeUrl = '/img/store_feature_mobile.png'
      } else {
        this.hospitalUrl = '/svg/hospital_feature.svg'
        this.storeUrl = '/svg/store_feature.svg'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixin.scss';

.el-row {
  @include wrap-flex;
}
.common-title {
  @include title-big;
  margin-bottom: 0.5vw;
}
.common-tip {
  font-size: 16px;
}
.common-btn {
  margin-top: 1vw;
}

/deep/ .el-carousel__container {
  height: 31.25vw;
}

.inter-health {
  height: $sessionHeight;
  padding: 2.5vw $mainPadding;
  text-align: center;

  .health-title {
    @include title-big;
    margin-bottom: 10vw;
  }
  .health-content {
    .menu {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      .menu-item {
        width: 15.625vw;
        height: 10.94vw;
        // padding: 3vw 0;
        border: 1px solid #f7fcfe;
        box-shadow: 0 10px 20px 6px rgba(228, 228, 228, 0.5);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        &:nth-child(1) {
          margin-bottom: 1.5vw;
        }
        &:nth-child(2) {
          margin-bottom: 1.5vw;
        }
        &:nth-child(2n) {
          margin-left: 1.5vw;
        }
        .el-image {
          width: 3.3vw;
        }
        .item-text {
          font-size: 1.15vw;
          text-align: center;
          margin-top: 0.52vw;
        }
      }
    }
  }
}

.inter-hospital {
  height: $sessionHeight;
  padding: 10vw $mainPadding;
  background-color: $bgColor;
  text-align: center;
  .hospital-image {
    width: 46vw;
  }
}
.clini_nutrit {
  height: $sessionHeight;
  padding: 10vw $mainPadding;
  text-align: center;
  .nutrition {
    display: flex;
    flex-wrap: wrap;
    .nutrition-item {
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 16.77vw;
      height: 11.4vw;
      @include wrap-flex;
      margin-bottom: 1vw;
      align-items: flex-start;
      padding-top: 3.6vw;
      &:nth-child(2n-1) {
        margin-right: 1vw;
      }
      &:nth-child(5) {
        margin-bottom: 0;
      }
      &:nth-child(6) {
        margin-bottom: 0;
      }
      .item-content {
        padding: 0 2vw;
        .item-title {
          font-size: 16px;
          margin-bottom: 0.5vw;
          font-weight: bold;
        }
        .item-tip {
          font-size: 14px;
        }
      }
    }
  }
}

.technical-super {
  height: 40vw;
  padding: 2.5vw $mainPadding;
  .technical-title {
    @include title-big;
    text-align: center;
    margin-bottom: 11.04vw;
  }
  .technical-temp {
    @include wrap-flex;
    .technical-content {
      width: 51.4vw;
      height: 15.93vw;
      background-image: url('/svg/technical_h.svg');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;

      .technical-item {
        flex: 1;
        padding: 6vw 2vw 0;
        text-align: center;
        &:nth-child(1) {
          padding-left: 1.5vw;
          padding-right: 2.5vw;
        }
        &:nth-child(3) {
          padding-left: 2.5vw;
          padding-right: 1.5vw;
        }
        .item-title {
          font-weight: bold;
          margin-bottom: 0.5vw;
        }
        .item-tip {
          font-size: 14px;
        }
      }
    }
  }
}

@media screen and (min-width: 992px) and (max-width: 1300px) {
  .technical-temp {
    .item-tip {
      font-size: 12px !important;
    }
  }
  // .clini_nutrit {
  //   .item-title {
  //     font-size: 14px !important;
  //   }
  //   .item-tip {
  //     font-size: 12px !important;
  //   }
  // }
}

@media screen and (max-width: 992px) {
  .mobile-padding {
    height: auto !important;
    padding: 5.33vw $mobilePadding !important;
  }
  .common-title {
    font-size: 4.27vw !important;
    margin-bottom: 3.2vw !important;
  }
  .common-tip {
    font-size: $mobileFontSize !important; // 14px
    margin-bottom: 5.33vw !important;
  }
  .common-btn {
    margin-top: 5.33vw;
    margin-bottom: 10.66vw;
    .el-button {
      width: 96px;
    }
  }
  /deep/ .el-carousel__container {
    height: 106.67vw;
  }
  .inter-health {
    .health-title {
      font-size: 4.27vw; // 14px
      margin-bottom: 5.33vw; // 20px
    }
    .health-content {
      .el-row {
        flex-direction: column-reverse;
      }
      .menu {
        justify-content: space-between;
        padding: 0 1.06vw;
        margin-bottom: 5.33vw;
        .menu-item {
          width: 44.26vw;
          height: 29.86vw;
          // padding: 10.2vw 0;
          &:nth-child(1) {
            margin-bottom: 2.93vw; // 11px
          }
          &:nth-child(2) {
            margin-bottom: 2.93vw;
          }
          &:nth-child(2n) {
            margin-left: 0vw;
          }
          .el-image {
            width: 11.2vw;
          }
          .item-text {
            font-size: 3.73vw;
            margin-top: 2.93vw;
          }
        }
      }
      .health-image {
        padding: 0 2.13vw;
      }
    }
  }
  .inter-hospital {
    .hospital-image {
      width: 100%;
    }
  }
  .clini_nutrit {
    .el-row {
      flex-direction: column-reverse;
    }
    .nutrition {
      justify-content: space-between;
      .nutrition-item {
        display: block;
        width: 45.33vw;
        height: 32vw;
        margin-bottom: 2.67vw;
        border: 1px solid #f7fcfe;
        box-shadow: 0 10px 20px 6px rgba(228, 228, 228, 0.5);
        padding-top: 5.3vw;
        .el-image {
          width: 11.73vw;
          height: 11.73vw;
          margin-bottom: 2.67vw;
        }
        .item-title {
          font-size: 3.73vw;
          font-weight: bold;
        }
      }
    }
  }
  .technical-super {
    .technical-title {
      font-size: 4.27vw;
      margin-bottom: 5.33vw;
    }
    .technical-temp-mobile {
      .technical-item {
        padding: 4.8vw 2.67vw 3.73vw !important;
        margin-bottom: 2.67vw;
        text-align: center;
        border: 1px solid #f7fcfe;
        box-shadow: 0 10px 20px 6px rgba(228, 228, 228, 0.5);
        display: flex;
        align-items: center;
        .el-image {
          width: 11.73vw;
          height: 11.73vw;
          margin-bottom: 2.67vw;
        }
        .item-content {
          flex: 1;
          text-align: left;
          margin-left: 2.67vw;
          .item-title {
            font-size: $mobileFontSize;
            font-weight: bold;
            margin-bottom: 2.67vw;
          }
          .item-tip {
            font-size: $mobileFontSize;
          }
        }
      }
    }
  }
}
</style>
